import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { ImageComponent } from "../../../../Pages/Home/Components/HomePageAfterSelectCategory";

const MainCategoryMobile = ({ category, handleCategoryClick }) => {

    return (<div className="container-fluid main-category-mobile" onClick={() => handleCategoryClick(category)}>
        <div className="row">
            <div className="col-2">
                <ImageComponent path={category.catFileName} />
            </div>
            <div className="col d-flex flex-column">
                <div className="d-flex align-items-center">
                    <span>{category.catDescription}</span>
                    <span className="ms-2 secondary-text">{`(${category.artCount})`}</span>
                </div>
                <span className="secondary-text">{category.catDetailDesc}</span>
            </div>
            <div className="col-2 d-flex align-items-center">
                <MdOutlineKeyboardArrowRight size={25} />
            </div>
        </div>
    </div>)
}

export default MainCategoryMobile